import { Check, ArrowUpRight, Cable, Building, PaintRoller, HardHat, Home, Wrench, Fence, Factory } from "lucide-react";
import { useLang, loc } from "../i18n";
import { Reveal, SectionHead } from "./Reveal";
import { scrollToId } from "../lib/scroll";

const ICONS = { Cable, Building, PaintRoller, HardHat, Home, Wrench, Fence, Factory };

export const Services = ({ services }) => {
  const { lang, t } = useLang();

  const order = (title) => {
    window.dispatchEvent(new CustomEvent("proalp:service", { detail: title }));
    scrollToId("#contacts");
  };

  return (
    <section id="services" data-testid="services-section" className="border-t border-white/10 bg-[#070707]">
      <div className="mx-auto max-w-[1500px] px-5 py-24 md:px-10 md:py-32">
        <SectionHead num={t.services.num} title={t.services.title} sub={t.services.sub} testid="services-head" />
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-12">
          {services.map((s, i) => {
            const Icon = ICONS[s.icon] || HardHat;
            const wide = i % 4 === 0 || i % 4 === 3;
            return (
              <Reveal key={s.id} delay={(i % 2) * 0.08} className={wide ? "lg:col-span-7" : "lg:col-span-5"}>
                <article
                  data-testid={`service-card-${s.id}`}
                  className="group flex h-full flex-col overflow-hidden border border-white/10 bg-[#0A0A0A] transition-colors duration-500 hover:border-[#FF5A00]/60"
                >
                  <div className="relative h-60 overflow-hidden md:h-72">
                    <img
                      src={s.image}
                      alt={loc(s.title, lang)}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-[linear-gradient(to_top,#0A0A0A_5%,transparent_60%)]" />
                    <div className="absolute left-5 top-5 flex h-12 w-12 items-center justify-center bg-[#FF5A00] text-white">
                      <Icon size={22} />
                    </div>
                  </div>
                  <div className="flex flex-1 flex-col p-6 md:p-8">
                    <h3 className="font-display text-2xl md:text-3xl uppercase tracking-wide">{loc(s.title, lang)}</h3>
                    <p className="mt-3 text-sm text-neutral-400">{loc(s.desc, lang)}</p>
                    <ul className="mt-5 space-y-2">
                      {(s.benefits?.[lang] || s.benefits?.pt || []).map((b, j) => (
                        <li key={j} className="flex items-center gap-3 text-sm text-neutral-300">
                          <Check size={15} className="shrink-0 text-[#FF5A00]" />
                          {b}
                        </li>
                      ))}
                    </ul>
                    <button
                      data-testid={`service-order-${s.id}`}
                      onClick={() => order(loc(s.title, lang))}
                      className="group/btn mt-7 flex w-fit items-center gap-3 border border-white/20 px-6 py-3 text-xs font-bold uppercase tracking-widest transition-colors hover:border-[#FF5A00] hover:bg-[#FF5A00] hover:text-white"
                    >
                      {t.services.order}
                      <ArrowUpRight size={14} className="transition-transform duration-300 group-hover/btn:-translate-y-1 group-hover/btn:translate-x-1" />
                    </button>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
